import { useState } from 'react';
import { resetPassword } from '../../api/auth';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../../styles/auth.css';

function ResetPassword() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    otp: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      return Swal.fire('Error', 'Passwords do not match', 'error');
    }

    try {
      await resetPassword({
        emailId: state?.emailId,
        otp: formData.otp,
        newPassword: formData.newPassword
      });

      Swal.fire('Success', 'Password reset successful', 'success');
      navigate('/login');
    } catch (err) {
      Swal.fire(
        'Error',
        err.response?.data?.message || 'Failed to reset password',
        'error'
      );
    }
  };

  return (
    <div className="reset-container">
      <h2>Reset Password</h2>

      <p className="reset-info">
        Enter the OTP sent to your email and choose a new password.
      </p>

      <form onSubmit={handleSubmit}>
        <input
          placeholder="Enter OTP"
          value={formData.otp}
          onChange={(e) =>
            setFormData({ ...formData, otp: e.target.value })
          }
          required
        />

        <input
          type="password"
          placeholder="New Password"
          value={formData.newPassword}
          onChange={(e) =>
            setFormData({ ...formData, newPassword: e.target.value })
          }
          required
        />

        <input
          type="password"
          placeholder="Confirm Password"
          value={formData.confirmPassword}
          onChange={(e) =>
            setFormData({ ...formData, confirmPassword: e.target.value })
          }
          required
        />

        <button type="submit">Reset Password</button>
      </form>

      <p className="redirect-text">
        <Link to="/login" className="back-login">
          Back to Login
        </Link>
      </p>
    </div>
  );
}

export default ResetPassword;
